export const REDUCER_INDEX = 'notifications'

export enum NOTIFICATIONS_STATUS {
  DEFAULT = 'DEFAULT',
  ERROR = 'ERROR',
  INFO = 'INFO',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING',
}

export enum NOTIFICATIONS_STATUS_ICONS {
  ERROR = 'cancel',
  INFO = 'info',
  SUCCESS = 'check',
  WARNING = 'warning',
}

export enum NOTIFICATIONS_LABELS {
  ERROR = 'Error',
  INFO = 'Información',
  SUCCESS = 'Finalización',
  WARNING = 'Precaución',
}
